import { useQuery } from 'react-query';

import { Person } from '../../../../backend/src/matter/person/person.entity';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetSubsetPersons = (matterId: string | null, subsetId: string | null, limit?: number) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Person[]>(
    [QueryEntity.SubsetPersons, { subsetId, limit }],
    async () => {
      const params = new URLSearchParams();
      if (limit) {
        params.append('limit', limit.toString());
      }
      return fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/persons?${params.toString()}`,
        fetchConfigGET,
      ).then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res.json();
      });
    },
    {
      enabled: !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
    },
  );
};
